






import { Component, Vue, Model, Emit } from 'vue-property-decorator';
import SearchPaginationTable from '@/components/search-pagination-table.vue';
import Dialog from '@/components/dialog.vue';
import moment from 'moment';
import { post, get } from '@/unite/api';
@Component({
  components: { SearchPaginationTable, Dialog }
})
export default class RunningwaterDetails extends Vue {
  mounted() {
    this.getType();
  }
  created() {
    // console.log(this.api.get('/admin/apply/list', this.pageData.info))
  }
  optionTitle: string = '';
  visible: boolean = false;
  modifyForm: any;
  rules: any[] = [];
  selectList: object[] = [];
  pageData: any = {
    url: '/back/v1/sys/define/list',
    isSearch: true, // 是否需要搜索框
    isPagination: true, // 是否后端分页
    isBtn: true, // 是否需要头部操作按钮
    info: {
      page_num: 10,
      page_index: 1
    }, // 传后端数据
    searchData: [
      {
        type: 'select', // text框
        model: 'unified_type', // 字段
        tip: '定义类型',
        placeholder: '请选择定义类型',
        data: []
      }
    ],
    btnData: [
      {
        name: '刷新列表',
        methods: 'refesh',
        type: 'success',
        loading: false
      },
      {
        name: '添加定义',
        methods: 'add',
        type: 'success',
        loading: false
      },
      {
        name: '导出定义',
        methods: 'downAll',
        type: 'downAll',
        loading: false
      }
    ],
    tableData: {
      stripe: true,
      border: true,
      expandShow: false,
      optionShow: true,
      header: [
        {
          prop: 'number',
          label: '电话'
        },
        {
          prop: 'unified_type',
          label: '类型'
        },
        {
          prop: 'name',
          label: '银行'
        }
      ],
      expand: [],
      optionWidth: 150,
      option: [
        {
          name: '修改定义',
          methods: 'modify',
          type: 'success',
          role: function(row: any) {
            return 1;
          }
        }
      ]
    } // table
  };
  dialogAddData: any = {
    modifyForm: {
      url: '/back/v1/sys/define/create',
      width: '35%',
      form: {
        unified_type: '',
        number: ''
      },
      showData: [],
      formLabelWidth: '100px',
      data: [
        {
          type: 'input',
          model: 'number',
          name: '电话号码'
        },
        {
          type: 'select',
          model: 'unified_type',
          name: '类型'
        }
      ],
      select: {
        unified_type: []
      }
    },
    rules: {
      number: [
        {
          required: true,
          message: '请输入电话号码',
          trigger: 'blur'
        }
      ],
      unified_type: [
        {
          required: true,
          message: '请输入类型',
          trigger: 'blur'
        }
      ]
    }
  };
  dialogModifyData: any = {
    modifyForm: {
      url: '/back/v1/sys/define/modify',
      width: '35%',
      form: {
        number: '',
        unified_code: ''
      },
      showData: [],
      formLabelWidth: '100px',
      data: [
        {
          type: 'input',
          model: 'number',
          name: '电话号码',
          disabled: true
        },
        {
          type: 'select',
          model: 'unified_code',
          name: '类型'
        }
      ],
      select: {
        unified_code: []
      }
    },
    rules: {
      name: [
        {
          required: true,
          message: '请输入定义名称',
          trigger: 'blur'
        }
      ]
    }
  };
  private handleClick(methods: string, row: any) {
    if (methods === 'modify') {
      this.optionTitle = '修改定义';
      this.dialogModifyData.modifyForm.form.number = row.number;
      this.dialogModifyData.modifyForm.form.unified_code = row.unified_type;
      this.visible = true;
      this.modifyForm = this.dialogModifyData.modifyForm;
      this.rules = this.dialogModifyData.rules;
    }
  }
  private btnClick(methods: string) {
    if (methods === 'add') {
      this.optionTitle = '添加定义';
      this.visible = true;
      this.modifyForm = this.dialogAddData.modifyForm;
      this.rules = this.dialogAddData.rules;
    }
  }
  // 刷新列表
  refesh(bool: boolean) {
    if (bool) {
      // @ts-ignore
      this.$refs.table.getData();
    }
    this.visible = false;
  }
  private getType() {
    get('/back/v1/sys/define/rule/list', {}).then(d => {
      // @ts-ignore
      console.log(d.Content);
      // @ts-ignore
      d.Content.forEach(item => {
        this.pageData.searchData[0].data = [
          ...this.pageData.searchData[0].data,
          { value: item.unified_type, label: item.unified_name }
        ];
        this.dialogAddData.modifyForm.select.unified_type = [
          ...this.dialogAddData.modifyForm.select.unified_type,
          { value: item.unified_type, label: item.unified_name }
        ];
        this.dialogModifyData.modifyForm.select.unified_code = [
          ...this.dialogModifyData.modifyForm.select.unified_code,
          { value: item.unified_type, label: item.unified_name }
        ];
      });
    });
  }
}
